import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  // CONTENEUR PRINCIPAL
  responseItemContainer: {
    width: '100%',
    padding: '16px 0',
  },
  
  // LAYOUT FLEXBOX POUR IMAGES
  imageAccordionLayout: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    width: '100%',
  },
  
  // LAYOUT FLEXBOX POUR TEXTE
  textAccordionLayout: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px',
    width: '100%',
  },
  
  // CONTAINERS
  imageContainer: {
    flexShrink: 0,
  },
  
  textInfoContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  
  textContentContainer: {
    flex: 1,
  },
  
  valueContainer: {
    flexShrink: 0,
    textAlign: 'right',
  },
  
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  
  // STYLES DES ÉLÉMENTS
  accordionResponseImage: {
    width: '140px',
    height: '100px',
    objectFit: 'cover',
    objectPosition: 'center',
    borderRadius: '9px',
    display: 'block',
  },
  
  responseTitle: {
    color: theme.palette.primary.light,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 600,
    margin: 0,
  },
  
  variableNameLabel: {
    color: '#23296F',
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 700,
    margin: 0,
  },
  
  variableNameText: {
    color: '#FF6B35',
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 700,
    textTransform: 'uppercase',
    wordBreak: 'break-word',
    margin: 0,
  },
  
  variableValueText: {
    color: '#23296F',
    fontFamily: 'Poppins',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 700,
    margin: 0,
  },
  
  // LEGACY
  overrideDividerClassname: {
    color: '#CDCEDA',
  },
}));

export default useStyles;
